import FileInput from "./FileInput";
import type { FileInputProps } from "./types";
import { identityWithExcel } from "./rules";
import { IdentityWithExcelPlaceholderTitle } from "./components";

const ProofFileInput = <TFormField extends string>(props: FileInputProps<TFormField>) => (
    <FileInput<TFormField>
        accept={identityWithExcel}
        {...props}
        placeholderProps={{
            sx: {
                opacity: 1
            },
            titleSlot: (
                <IdentityWithExcelPlaceholderTitle />
            ),
            subtitleSlot: <></>,
            ...props.placeholderProps
        }}
    />
);

export default ProofFileInput;
